import { FormActions } from "../../../components/common/FormActions";
import { IFormSection } from "../../../types/common";
import { API_FLOAT_INTEREST_CONFIGS } from "../../../utils/apis";
import { BOOLEAN_SELECTIONS } from "../../../utils/constants";
import {
  createViewEdit,
  formatCurrency,
  formatDateTime,
  getForm,
} from "../../../utils/helpers";
import { URL_FLOAT_INTEREST_CONFIGS } from "../../../utils/urls";

const url = URL_FLOAT_INTEREST_CONFIGS;

export const useFloatInterestConfigs = () => {
  const tableColumns = () => [
    {
      id: "name",
      header: "Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "annual_interest_rate",
      header: "Annual Interest ",
    },
    {
      id: "telecom_fee_rate",
      header: "Telecom Fee ",
    },
    {
      id: "boa_share_rate",
      header: "Partner Share",
    },
    {
      id: "onepayx_share_rate",
      header: "OnePayX Share ",
    },
    {
      id: "created_at",
      header: "Created At",
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        created_at: formatDateTime(item?.created_at),
        actions: <FormActions actions={[...createViewEdit(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Revenue Sharing Details",
          fields: {
            name: item?.name,
            annual_interest_rate: formatCurrency(item?.annual_interest_rate),
            telecom_fee_rate: formatCurrency(item?.telecom_fee_rate),
            boa_share_rate: formatCurrency(item?.boa_share_rate),
            onepayx_share_rate: formatCurrency(item?.onepayx_share_rate),
            auto_post_to_ledger: item?.auto_post_to_ledger,
            notes: item?.notes,
            escrow_account: item?.escrow_account,
            telecom_fee_account: item?.telecom_fee_account,
            boa_revenue_account: item?.boa_revenue_account,
            onepayx_revenue_account: item?.onepayx_revenue_account,
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  return { tableColumns, tableData, viewData, formRoute };
};

export const useFloatInterestConfigsForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Revenue Sharing",
      fields: [
        {
          field_name: "name",
          label: "Name",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "annual_interest_rate",
          label: "Annual Interest Rate(%)",
          type: "decimal",
          props: { required: true },
        },
        {
          field_name: "telecom_fee_rate",
          label: "Telecom Fee Rate(%)",
          type: "decimal",
          props: { required: true },
        },
        {
          field_name: "boa_share_rate",
          label: "BOA Share Rate(%)",
          type: "decimal",
          props: { required: true },
        },
        {
          field_name: "onepayx_share_rate",
          label: "OnepayX Share Rate(%)",
          type: "decimal",
          props: { required: true },
        },
        {
          field_name: "escrow_account",
          label: "Escrow Account",
          type: "select",
          props: { required: true },
          options_data: [],
        },
        {
          field_name: "telecom_fee_account",
          label: "Telecom Fee Account",
          type: "select",
          props: { required: true },
          options_data: [],
        },
        {
          field_name: "boa_revenue_account",
          label: "BOA Revenue Account",
          type: "select",
          props: { required: true },
          options_data: [],
        },
        {
          field_name: "onepayx_revenue_account",
          label: "OnepayX Revenue Account",
          type: "select",
          props: { required: true },
          options_data: [],
        },
        {
          field_name: "auto_post_to_ledger",
          label: "Auto Post to Ledger",
          type: "select",
          props: { required: true },
          options_data: BOOLEAN_SELECTIONS,
        },
        {
          field_name: "notes",
          label: "Notes",
          type: "textarea",
          props: { required: false },
        },
        {
          field_name: "is_active",
          label: "Is Active",
          type: "select",
          props: { required: true },
          options_data: BOOLEAN_SELECTIONS,
        },
      ],
    },
  ];

  function onSubmit(payload: any, id: string) {
    if (id) {
      return {
        id,
        api: API_FLOAT_INTEREST_CONFIGS,
        params: {
          ...payload,
        },
      };
    }
    return {
      api: API_FLOAT_INTEREST_CONFIGS,
      params: {
        ...payload,
      },
    };
  }

  return {
    sections,
    onSubmit,
  };
};
